import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import logo from '../assets/green-coke-logo.jpg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    // { path: '/products', label: 'Products & Services' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full bg-[#14372F] shadow-lg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center space-x-3 hover:opacity-90 transition-opacity"
          >
            <img
              src={logo}
              alt="Green Metallurgical Coke and Green Energy"
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-[#C0D8A3] ${
                  isActive(link.path) ? 'text-[#C0D8A3]' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            {/* <Button
              asChild
              className="//bg-[#C0D8A3] bg-[#C0D8A3] hover:bg-[#27ae60] text-white font-medium px-6 py-2.5 transition-all hover:shadow-lg"
            >
              <Link to="/contact">Request Quote</Link>
            </Button> */}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-white/10 transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-white" />
            ) : (
              <Menu className="h-6 w-6 text-white" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-white/20">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`text-sm font-medium transition-colors hover:text-[#C0D8A3] px-2 py-1 ${
                    isActive(link.path) ? 'text-[#C0D8A3]' : 'text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              {/* <Button
                asChild
                className="bg-[#C0D8A3] hover:bg-[#27ae60] text-white font-medium w-full"
                onClick={() => setIsMenuOpen(false)}
              >
                <Link to="/contact">Request Quote</Link>
              </Button> */}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;